// extracted by mini-css-extract-plugin
module.exports = {"bkw-K":"K_bkw-K__yCrgu"};